<template>
<div>
    <div v-if="isLoading" class="center pt-5">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando contenido...</span>
        </div>
    </div>
   <DeptoBase v-else
    :goal="maquila.meta_semana"
    :progress="maquila.progress"
    :name="maquila.nombre"
    :depto="maquila.depto"
    :days="maquila.dias_laborados"
    :m3="maquila.m3_persona"
    :bonus_p="maquila.bono_persona"
    :bonus_tot="maquila.bono_depto"
    :asis="maquila.asistencia"
    :extra="maquila.$_extra_m3"
    :bonus_prod="maquila.bono_productividad"
    :bonus_goals="maquila.bono_metas"
    :descuento="maquila.descuento_fr"
    />
</div>
</template>


<script>
import DeptoBase from '@/components/DeptoBase';

export default {
    name: 'Maquila',
    components: {DeptoBase},
    created() {
        this.$store.dispatch("plants/getInfo", {
            department: 'maquila',
            userCode: this.$route.params.user,
            city: 'rosarito'
        }); 
    },
    computed: {
        isLoading() {
            return this.$store.getters["plants/loading"];
        },
        maquila() {
        return this.$store.getters["plants/data"];
        }
    }
}
</script>